import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pay-form-error',
  imports: [],
  templateUrl: './form-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormErrorComponent {}
